<template>
  <div class="c-sitter__feedback">
    <fieldset id="bad_public_feedback" class="c-feedback__form" name="bad_public_feedback">
      <legend class="h3 c-rating__question">We’re sorry to hear you had an unsatisfactory experience.</legend>
      <span class="c-optional__label">Optional</span>
      <p class="c-feedback__title">Leave a public review of {{ sitterFirstName }}.</p>
      <PoppinsTextArea
        id="update_review_text"
        v-model="publicFeedback"
        class="mb-32 review-feedback-box"
        labelName="Your review..."
        :rows="6"
        @keyupOnce="ratingSegmentEvent('Review Started')"
        @input="onInput"
      />
      <PoppinsButton
        id="updateReview"
        type="submit"
        size="medium"
        class="mr-8 w-full sm:!w-auto"
        value="Post review"
        @click.prevent="updateReview"
      />
      <PoppinsButton
        value="Skip"
        :href="returnPath"
        variant="text"
        class="w-full sm:!w-auto mt-16 sm:!mt-0"
        @click="ratingSegmentEvent('Review Skipped')"
      />
    </fieldset>
  </div>
</template>

<script lang="ts">
import TextArea from '@/components/textarea/TextArea.vue';
import Button from '@/components/button/Button.vue';

export default {
  name: 'UpdateFeedback',
  components: {
    PoppinsTextArea: TextArea,
    PoppinsButton: Button,
  },
  props: {
    returnPath: {
      type: String,
      required: true,
    },
    updateReview: {
      type: Function,
      required: true,
    },
    sitterFirstName: {
      type: String,
      required: true,
    },
    ratingSegmentEvent: {
      type: Function,
      required: false,
      default: () => {},
    },
  },
  data(): any {
    return {
      publicFeedback: '',
    };
  },
  methods: {
    onInput() {
      this.$emit('input', this.publicFeedback);
    },
  },
};
</script>
